import React from 'react';

const DraftCostInvoiceModal = ({
  isOpen,
  onClose,
  invoiceType,
  setInvoiceType,
  selectedJobsCount,
  onGenerate,
  onCancel,
}) => {
  if (!isOpen) return null;

  const isStep1 = !invoiceType;
  const isStep2 = !!invoiceType;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        width: 'auto',
        minWidth: '400px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
      }}>
        <h3 style={{
          marginBottom: '16px',
          fontSize: '18px',
          fontWeight: '600',
          color: '#1f2937'
        }}>
          Generate Cost Invoice
        </h3>

        {isStep1 && (
          <>
            <div style={{
              padding: '16px',
              backgroundColor: '#f9fafb',
              borderRadius: '8px',
              marginBottom: '20px',
              border: '1px solid #e5e7eb'
            }}>
              <p style={{
                fontSize: '14px',
                color: '#6b7280',
                marginBottom: 0,
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
                lineHeight: '1.6'
              }}>
                <span className="combine-charges-info-icon">!</span>
                The selected Job include both Material Code and GL Code charges,<br />
                please choose how you want to generate the cost bill.
              </p>
            </div>

            <div style={{
              marginBottom: '10px',
              display: 'flex',
              gap: '10px',
            }}>
              <div>
                <label className="pill-option">
                  <input
                    type="radio"
                    name="poType"
                    checked={invoiceType === "po"}
                    onChange={() => setInvoiceType("po")}
                  />
                  <span className="po-custom-radio"></span>
                  <span className="po-custom-text">PO</span>
                </label>
              </div>

              <div>
                <label className="pill-option">
                  <input
                    type="radio"
                    name="poType"
                    checked={invoiceType === "non_po"}
                    onChange={() => setInvoiceType("non_po")}
                  />
                  <span className="po-custom-radio"></span>
                  <span className="po-custom-text">Non-PO</span>
                </label>
              </div>
            </div>
          </>
        )}

        {isStep2 && (
          <div style={{
            padding: '20px 0',
            textAlign: 'center',
            borderTop: '1px solid #e5e7eb',
            borderBottom: '1px solid #e5e7eb',
            margin: '20px 0'
          }}>
            <p style={{
              fontSize: '16px',
              color: '#374151',
              marginBottom: '8px'
            }}>
              {`Generate ${invoiceType === "po" ? "PO" : "Non-PO"} Cost Invoice`}
            </p>
            <p style={{
              fontSize: '14px',
              color: '#6b7280'
            }}>
              {`Are you sure you want to generate cost invoice for ${selectedJobsCount} selected jobs?`}
            </p>
          </div>
        )}

        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
          marginTop: '10px'
        }}>
          {isStep1 ? (
            <>
              <button
                onClick={onCancel}
                style={{
                  backgroundColor: '#6c757d',
                  color: '#fff',
                  border: 'none',
                  padding: '6px 14px',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  height: '32px',
                  fontSize: '13px',
                  fontWeight: '500',
                  fontFamily: "'Work Sans', sans-serif",
                  boxShadow: '0 2px 6px rgba(108, 117, 125, 0.3)',
                  transition: 'background-color 0.2s, transform 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#565e64';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#6c757d';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  if (!invoiceType) {
                    return; 
                  }
                }}
                disabled={!invoiceType}
                style={{
                  backgroundColor: !invoiceType ? '#ccc' : '#007bff',
                  color: '#fff',
                  border: 'none',
                  padding: '6px 14px',
                  borderRadius: '20px',
                  cursor: invoiceType ? 'pointer' : 'not-allowed',
                  height: '32px',
                  fontSize: '13px',
                  fontWeight: '500',
                  fontFamily: "'Work Sans', sans-serif",
                  boxShadow: '0 2px 6px rgba(0, 123, 255, 0.3)',
                  transition: 'background-color 0.2s, transform 0.2s'
                }}
                onMouseEnter={(e) => {
                  if (invoiceType) {
                    e.target.style.backgroundColor = '#0056b3';
                    e.target.style.transform = 'translateY(-1px)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (invoiceType) {
                    e.target.style.backgroundColor = '#007bff';
                    e.target.style.transform = 'translateY(0)';
                  }
                }}
              >
                Next
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => setInvoiceType("")}
                style={{
                  backgroundColor: '#6c757d',
                  color: '#fff',
                  border: 'none',
                  padding: '6px 14px',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  height: '32px',
                  fontSize: '13px',
                  fontWeight: '500',
                  fontFamily: "'Work Sans', sans-serif",
                  boxShadow: '0 2px 6px rgba(108, 117, 125, 0.3)',
                  transition: 'background-color 0.2s, transform 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#565e64';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#6c757d';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Back
              </button>

              <button
                onClick={onGenerate}
                style={{
                  backgroundColor: '#007bff',
                  color: '#fff',
                  border: 'none',
                  padding: '6px 14px',
                  borderRadius: '20px',
                  cursor: 'pointer',
                  height: '32px',
                  fontSize: '13px',
                  fontWeight: '500',
                  fontFamily: "'Work Sans', sans-serif",
                  boxShadow: '0 2px 6px rgba(0, 123, 255, 0.3)',
                  transition: 'background-color 0.2s, transform 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#0056b3';
                  e.target.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#007bff';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                Generate
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DraftCostInvoiceModal;